/**
 * Licensed Materials - Property of IBM
 *
 * "Restricted Materials of IBM"
 *
 * (C) Copyright IBM Corp. 2018, 2020
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import SlotAPIAdapter from './SlotAPIAdapter';
const _ = require('underscore');

/**
 * This class works as an apdater of VisAPI Class (please find VisAPI in dashboard-livewidget for more informaiton)
 * This adapter is needed when creating VIPRData for Relationship Diagram
 * //TODO: visAPI should be deprecated
 */
export default class VisAPIAdapter {
	/**
	 *@constructor
	 *@param {Object} definition - The Vis definition object
	 */
	constructor(definition) {
		this.definition = definition;
	}

	/**
	 *Return the mapped slots list
	 */
	getSlots() {
		return {
			getMappedSlotList: ()=> {
				return this.definition.dataSlots.map((slot)=>{
					return new SlotAPIAdapter(slot);
				});
			}
		};
	}

	/**
	 *Return the livewidget vis definition object
	 */
	getDefinition() {
		return {
			getId: () => this.definition.id,
			getDatasetList: () => {
				return _.map(this.definition.datasets, function (dataset) {
					return {
						id: dataset.name,
						caption: dataset.caption,
						optional: dataset.optional,
						suppressMissing: dataset.suppressMissing,
						needsSorted: dataset.needsSorted,
						requiresValues: dataset.requiresValues
					};
				});
			}
		};
	}

	/**
	* @param {String} dataViewId - the data view ID of the dataset
	*/
	getDataSlotsForViewId(dataViewId) {
		const aSlotAPIAdapter = [];
		if(this.definition){
			_.each(this.definition.dataSlots, function(slot){
				if ( slot.datasetIdList[0] === dataViewId ){
					aSlotAPIAdapter.push(new SlotAPIAdapter(slot));
				}
			});
		}
		return aSlotAPIAdapter;
	}
}



// WEBPACK FOOTER //
// ./src/js/components/startingPoints/relationshipGraph/VisAPIAdapter.js